import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const MAX_TRIGGERS = 3;

const TriggerMeter = ({triggerCount=0, otherTriggerCount=0, color}) => { 
    let triggers = triggerCount + otherTriggerCount;
    let style = {
        width: Math.min(100, 100.0 * triggers / MAX_TRIGGERS) + '%',
        backgroundColor: color
    };
    return (
        <div className="trigger-meter">
          <div style={style} className="trigger-meter-indicator">
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      triggerCount: props.track.triggerCount,
      otherTriggerCount: props.track.otherTriggerCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TriggerMeter);
